import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Img from 'gatsby-image'
import moment from 'moment'

import postDetailStyles from './postDetail.module.css'

class ProgramTemplate extends React.Component {
  render() {
    const post = get(this.props, 'data.contentfulProgram')
    const siteData = get(this.props, 'data.site.siteMetadata')

    return (
      <div style={{ background: '#fff' }} className="page-content page-program-detail">
        <Helmet title={`${post.title} | ${siteData.title}`}>
          <link rel="canonical" href={`${siteData.siteUrl}/article/${post.slug}`} />
          <meta name="description" content={`${post.excerpt}`} />
          <meta name="title" content={`${post.title} | ${siteData.title}`} />

          <meta property="og:title" content={`${post.title} | ${siteData.title}`} />
          <meta property="og:site_name" content="YOUCAT Indonesia" />
          <meta property="og:url" content={`${siteData.siteUrl}/program/${post.slug}`} />
          <meta property="og:description" content={`${post.excerpt}`}  />
          <meta property="og:image" content="https://static.youcat.id/ogimg/ogimg-youcat.png" />
          <meta property="og:locale" content="id_ID" />
          <meta property="og:type" content="article" />

        </Helmet>
        <div className={`grid-x grid-padding-x grid-padding-y`}>
          <div className={`program-image post-image cell medium-shrink ${postDetailStyles.postThumbWrapper}`}>
            <Img className={postDetailStyles.postThumb} alt={post.title} sizes={post.thumbnail.sizes} />
          </div>
          <div className="cell medium-auto">
            <h1 className={postDetailStyles.postTitle}>{post.title}</h1>
            <small>Kategori: { post.programCategory }</small>
            <div className={postDetailStyles.bodyContent}
              dangerouslySetInnerHTML={{
                __html: post.body.childMarkdownRemark.html,
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default ProgramTemplate

export const pageQuery = graphql`
  query ProgramBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        siteUrl
        siteImg
      }
    }
    contentfulProgram(slug: { eq: $slug }) {
      title
      slug
      excerpt
      thumbnail {
        sizes(maxWidth: 1180, background: "rgb:000000") {
          ...GatsbyContentfulSizes_withWebp
        }
      }
      body {
        childMarkdownRemark {
          html
        }
      }
      programCategory
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/program-post.js